<template>
  <div id="app">
    <!-- 滚动进度条 -->
    <div id="scroll-progress"><span ref="scrollBar"></span></div>

    <AppHeader />

    <router-view />

    <!-- 全局浮动二维码 -->
    <FloatingQR />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import FloatingQR from './components/FloatingQR.vue'

export default {
  name: 'App',
  components: { AppHeader, FloatingQR },
  mounted() {
    // 滚动进度条
    const bar = this.$refs.scrollBar
    const update = () => {
      const doc = document.documentElement
      const max = doc.scrollHeight - doc.clientHeight
      const p = max <= 0 ? 0 : (doc.scrollTop / max) * 100
      if (bar) bar.style.width = `${Math.min(100, Math.max(0, p))}%`
    }
    window.addEventListener('scroll', update, { passive: true })
    this._onLocaleChange = () => {
      const key = (this.$route && this.$route.meta && this.$route.meta.titleKey) || 'titles.default'
      document.title = this.$t(key)
    }
    window.addEventListener('localechange', this._onLocaleChange)
    update()
    this._scrollCleanup = () => window.removeEventListener('scroll', update)
  },
  beforeDestroy() {
    if (this._scrollCleanup) this._scrollCleanup()
    if (this._onLocaleChange) window.removeEventListener('localechange', this._onLocaleChange)
  }
}
</script>
